import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postLiftingIssue = (params) => {
    return axios.post(`${backendHost}/api/admin/lifting/issue`, params);
};

export {
    postLiftingIssue
}